import { Grid2 } from '@mui/material';

export const HeaderGrid = (props: React.ComponentProps<typeof Grid2>) => (
    <Grid2
        {...props}
        sx={{
            backgroundColor: '#F2F4F7',
            padding: '8px 8px',
            ...(props.sx || {})
        }}
    />
);

export const NormalGrid = (props: React.ComponentProps<typeof Grid2>) => (
    <Grid2
        {...props}
        sx={{
            padding: '0px 8px 0px',
            ...(props.sx || {})
        }}
    />
);
